import { render, staticRenderFns } from "./MultipleHistCharts.vue?vue&type=template&id=4b6ce449&scoped=true"
import script from "./MultipleHistCharts.vue?vue&type=script&lang=js"
export * from "./MultipleHistCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ce449",
  null
  
)

export default component.exports